import { ReturnBlock } from "../ReturnBlock";

/**
 * Assembly block for ternary statement (condition ? tValue : fValue)
 */
export class TernaryBlock extends ReturnBlock {

    condition: ReturnBlock;
    tValue: ReturnBlock;
    fValue: ReturnBlock;

    /**
     * Constructor
     * @param inputs the inputs. Condition is index 0, true value is index 1, false value is index 2
     */
    constructor(id: string, inputs: ReturnBlock[]) {
        super(id)
        this.condition = inputs[0];
        this.tValue = inputs[1];
        this.fValue = inputs[2];
    }

    /**
     * Evaluates the expression.
     * @param varEnv variable environment
     * @returns the value of 'condition ? tValue : fValue' expression
     */
    evalBlock(varEnv: Map<string, any>): any {
        let condition = Boolean(this.condition.evalBlock(varEnv));

        let value;
        if (condition) {
            value = this.tValue.evalBlock(varEnv);
        } else {
            value = this.fValue.evalBlock(varEnv);
        }

        return value;
    }
}